import React, { useContext, useEffect, useState } from 'react'
import '../styles/sigIn.css'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Paper, TextField, Typography } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from 'store/rootStore'
import { HOME_URL } from 'constants/urls'
import useRoutes from 'hooks/useRoutes'
import BackdropLoader from 'asterX-UIkit/Loaders/BackdropLoader'

const SignIn = observer(() => {
  const { authStore } = useContext(RootStoreContext)
  const { t } = useTranslation()
  const { prevPage, push } = useRoutes()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleUsername = e => {
    setUsername(e.target.value)
  }
  const handlePassword = e => {
    setPassword(e.target.value)
  }

  useEffect(() => {
    if (authStore.user.token) {
      push(prevPage ? prevPage : HOME_URL)
    }
  }, [authStore.user.token])

  const login = () => {
    const data = {
      username: username,
      password: password
    }
    authStore.login(data)
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <BackdropLoader loading={authStore.loading} />
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justify="center"
        style={{ minHeight: '70vh' }}
      >
        <Grid item xs={12}>
          <form>
            <Paper
              style={{
                padding: '60px',
                paddingBottom: '60px',
                minWidth: '250px',
                maxWidth: '300px'
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="h5" component="h3">
                    {t('Authorization')}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    style={{ width: '100%' }}
                    id="username"
                    name="username"
                    autoComplete="username"
                    value={username}
                    label={t('username')}
                    type="text"
                    margin="normal"
                    onChange={handleUsername}
                    required
                  />
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: '20px' }}>
                  <TextField
                    style={{ width: '100%' }}
                    value={password}
                    id="password"
                    name="password"
                    autoComplete="current-password"
                    label={t('password')}
                    type="password"
                    onChange={handlePassword}
                    margin="normal"
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    className="button"
                    onClick={login}
                    autoFocus
                    style={{
                      marginTop: '30px',
                      width: '100%'
                    }}
                  >
                    {t('sigIn')}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Grid>
      </Grid>
    </div>
  )
})

export default SignIn
